import { Link } from "react-router-dom";
import { galleryItems } from "../../../mocks/gallery";

export default function GalleryPreview() {
  const preview = galleryItems.slice(0, 5);

  return (
    <section className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        {/* Header */}
        <div className="flex flex-col md:flex-row md:items-end justify-between mb-12 gap-4">
          <div>
            <p className="text-[#B8956A] text-xs tracking-[0.3em] uppercase mb-3" style={{ fontFamily: "'Noto Serif JP', serif" }}>
              Gallery
            </p>
            <h4 id="gallery" className="text-3xl text-[#3D2E2A]" style={{ fontFamily: "'Noto Serif JP', serif", fontWeight: 400 }}>
              <a href="#gallery">最新の施術ギャラリー</a>
            </h4>
          </div>
          <Link
            to="/gallery"
            className="inline-flex items-center gap-2 text-[#B8956A] text-sm tracking-wider border-b border-[#B8956A] pb-0.5 hover:text-[#A07B55] transition-colors cursor-pointer whitespace-nowrap"
            style={{ fontFamily: "'Noto Sans JP', sans-serif" }}
          >
            すべて見る
            <span className="w-4 h-4 flex items-center justify-center"><i className="ri-arrow-right-line text-sm" /></span>
          </Link>
        </div>

        {/* Asymmetric Grid */}
        <div className="grid grid-cols-2 md:grid-cols-3 gap-4">
          {/* Large left item */}
          <div className="row-span-2 rounded-xl overflow-hidden border border-[#EDE7DF] relative group cursor-pointer">
            <div className="w-full h-full min-h-[420px]">
              <img
                src={preview[0].image}
                alt={preview[0].title}
                className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
              />
            </div>
            <div className="absolute inset-0 bg-gradient-to-t from-black/50 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex items-end p-4">
              <div>
                <span className="text-[#C9A86A] text-xs tracking-wider" style={{ fontFamily: "'Noto Sans JP', sans-serif" }}>{preview[0].category}</span>
                <p className="text-white text-sm font-medium" style={{ fontFamily: "'Noto Serif JP', serif" }}>{preview[0].title}</p>
              </div>
            </div>
          </div>

          {/* Right items */}
          {preview.slice(1).map((item) => (
            <div key={item.id} className="rounded-xl overflow-hidden border border-[#EDE7DF] relative group cursor-pointer h-48 md:h-auto md:min-h-[200px]">
              <div className="w-full h-full min-h-[200px]">
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
              </div>
              <div className="absolute inset-0 bg-gradient-to-t from-black/50 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex items-end p-4">
                <div>
                  <span className="text-[#C9A86A] text-xs tracking-wider" style={{ fontFamily: "'Noto Sans JP', sans-serif" }}>{item.category}</span>
                  <p className="text-white text-sm font-medium" style={{ fontFamily: "'Noto Serif JP', serif" }}>{item.title}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
